<div class="flex min-h-dvh w-full items-center justify-center px-4">
    <app-session-card>
        @switch (sessionState()) {
            @case (SessionState.CustomerContextError) {
                <ng-template appSessionCardHeader>
                    <app-session-card-logo />
                </ng-template>
                <ng-template appSessionCardBody>
                    <span class="pt-12 text-center font-serif text-xl leading-snug font-bold whitespace-pre-line">
                        {{ text().ContextErrorTitle }}
                    </span>
                    <span class="text-center font-serif">{{ text().ContextErrorMessage }}</span>
                </ng-template>
                <ng-template appSessionCardActions>
                    <div class="flex flex-col gap-2">
                        <button pButton class="w-full" (click)="retry()">{{ text().Retry }}</button>
                        <button pButton class="w-full" severity="secondary" (click)="selectCustomer()">
                            {{ text().SelectCustomer }}
                        </button>
                    </div>
                </ng-template>
            }
            @case (SessionState.AuthenticationError) {
                <ng-template appSessionCardHeader>
                    <app-session-card-logo />
                </ng-template>
                <ng-template appSessionCardBody>
                    <span class="pt-12 text-center font-serif text-xl leading-snug font-bold whitespace-pre-line">
                        {{ text().GenericErrorTitle }}
                    </span>
                    <span class="text-center font-serif">{{ text().GenericErrorMessage }}</span>
                </ng-template>
                <ng-template appSessionCardActions>
                    <button pButton class="w-full" (click)="retry()">{{ text().Retry }}</button>
                </ng-template>
            }
            @case (SessionState.CustomerAccessError) {
                <ng-template appSessionCardHeader>
                    <app-session-card-logo />
                </ng-template>
                <ng-template appSessionCardBody>
                    <span class="pt-12 text-center font-serif text-xl leading-snug font-bold whitespace-pre-line">
                        {{ text().GenericErrorTitle }}
                    </span>
                    <span class="text-center font-serif">{{ text().GenericErrorMessage }}</span>
                </ng-template>
                <ng-template appSessionCardActions>
                    <button pButton class="w-full" (click)="retry()">{{ text().Retry }}</button>
                </ng-template>
            }
            @case (SessionState.CustomerUnavailable) {
                <ng-template appSessionCardHeader>
                    <app-session-card-logo />
                </ng-template>
                <ng-template appSessionCardBody>
                    <span class="pt-12 text-center font-serif text-xl leading-snug font-bold whitespace-pre-line">
                        {{ text().GenericErrorTitle }}
                    </span>
                    <span class="text-center font-serif">{{ text().GenericErrorMessage }}</span>
                </ng-template>
                <ng-template appSessionCardActions>
                    <button pButton class="w-full" (click)="retry()">{{ text().Retry }}</button>
                </ng-template>
            }
            @case (SessionState.LoadingAuthentication) {
                <ng-template appSessionCardHeader>
                    <p-progress-spinner />
                </ng-template>
                <ng-template appSessionCardBody>
                    <span class="pt-12 text-center font-serif text-xl leading-snug font-bold whitespace-pre-line">
                        {{ text().LoadingTitle }}
                    </span>
                    <span class="text-center font-serif">{{ text().LoadingMessage }}</span>
                </ng-template>
            }
            @case (SessionState.LoadingCustomerAccess) {
                <ng-template appSessionCardHeader>
                    <p-progress-spinner />
                </ng-template>
                <ng-template appSessionCardBody>
                    <span class="pt-12 text-center font-serif text-xl leading-snug font-bold whitespace-pre-line">
                        {{ text().LoadingTitle }}
                    </span>
                    <span class="text-center font-serif">{{ text().LoadingMessage }}</span>
                </ng-template>
            }
            @case (SessionState.LoadingCustomerContext) {
                <ng-template appSessionCardHeader>
                    <p-progress-spinner />
                </ng-template>
                <ng-template appSessionCardBody>
                    <span class="pt-12 text-center font-serif text-xl leading-snug font-bold whitespace-pre-line">
                        {{ text().LoadingTitle }}
                    </span>
                    <span class="text-center font-serif">{{ text().LoadingMessage }}</span>
                </ng-template>
            }
        }
    </app-session-card>
</div>
